import { Controller } from '@hotwired/stimulus'

/**
 * Фильтрует уже отрисованный географический каталог без сетевых запросов.
 * Это сохраняет буквенную навигацию и даёт мгновенный поиск даже на медленном соединении.
 */
export default class DirectoryFilterController extends Controller {
  static targets = ['input', 'item', 'city', 'section', 'letter', 'empty']

  filter() {
    const query = this.normalize(this.inputTarget.value)
    const searchStarts = query.length > 0 && !this.searchActive
    const searchEnds = query.length === 0 && this.searchActive

    if (searchStarts) {
      this.itemTargets.forEach((item) => {
        item.dataset.directoryFilterWasOpen = item.classList.contains('is-open')
      })
    }

    this.itemTargets.forEach((item) => {
      const countryMatches = this.normalize(
        item.dataset.directoryFilterCountryValue
      ).includes(query)
      const cities = this.cityTargets.filter((city) => item.contains(city))
      let cityMatches = false

      cities.forEach((city) => {
        const matches =
          countryMatches ||
          this.normalize(city.dataset.directoryFilterCityValue).includes(query)
        city.hidden = !matches
        cityMatches ||= matches
      })

      item.hidden = !(countryMatches || cityMatches)

      if (cities.length > 0 && query.length > 0) {
        // Раскрываем совпавшую страну, иначе найденный город останется визуально спрятан в аккордеоне.
        this.setExpanded(item, !item.hidden)
      } else if (cities.length > 0 && searchEnds) {
        this.setExpanded(item, item.dataset.directoryFilterWasOpen === 'true')
        delete item.dataset.directoryFilterWasOpen
      }
    })

    this.sectionTargets.forEach((section, index) => {
      const hasMatches = this.itemTargets.some(
        (item) => section.contains(item) && !item.hidden
      )
      section.hidden = !hasMatches
      if (this.letterTargets[index]) this.letterTargets[index].hidden = !hasMatches
    })

    this.emptyTarget.hidden = this.itemTargets.some((item) => !item.hidden)
    this.searchActive = query.length > 0
  }

  clear(event) {
    event?.preventDefault()
    this.inputTarget.value = ''
    this.filter()
    this.inputTarget.focus()
  }

  normalize(value) {
    return value.toLocaleLowerCase().trim()
  }

  setExpanded(item, expanded) {
    const button = item.querySelector('[data-faq-target~="button"]')
    const panel = item.querySelector('[data-faq-target~="content"]')
    if (!button || !panel) return

    item.classList.toggle('is-open', expanded)
    button.setAttribute('aria-expanded', expanded.toString())
    panel.hidden = !expanded
    panel.setAttribute('aria-hidden', (!expanded).toString())
  }
}
